import List16 from '@carbon/icons-react/es/list/16';
import Roadmap16 from '@carbon/icons-react/es/roadmap/16';
import { Tooltip } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { IconShell } from 'components/atoms/icon-shell';
import { LinkGroup as OzoneLinkGroup } from 'components/atoms/link-group';

const Views = [
  {
    id: 'list',
    icon: <List16 />,
    key: 'board_view',
    path: '',
  },
  {
    id: 'timeline',
    icon: <Roadmap16 />,
    key: 'timeline_view',
    path: '/timeline',
  },
];

const LinkGroup = styled(OzoneLinkGroup)`
  .ant-radio-button-wrapper {
    > svg {
      margin-right: var(--spacing-03);
    }

    &:hover {
      background-color: var(--gray-10);
    }

    &.active {
      border-color: var(--black-100);
      background-color: var(--black-100);
      color: var(--white-100);
      &:not(.ant-radio-button-wrapper-disabled)::before {
        background-color: var(--black-100);
      }
    }
    :last-child,
    :first-child {
      border-radius: 0;
    }
  }
`;

export const ViewGroup: FC<{ projectId: number }> = ({ projectId }) => {
  return (
    <LinkGroup>
      {Views.map((view) => (
        <OzoneLinkGroup.Anchor
          key={view.id}
          to={`/projects/${projectId}/plan${view.path}`}
        >
          <Tooltip
            title={<FormattedMessage id={view.key} />}
            mouseEnterDelay={0.8}
          >
            <div>
              <IconShell icon={view.icon} />
            </div>
          </Tooltip>
        </OzoneLinkGroup.Anchor>
      ))}
    </LinkGroup>
  );
};
